import { PLACEHOLDERS } from '@/types/const/placeholders'
import { capitalize } from '@/utils/wording-util/wordingUtil'

export const toTitleCase = (input: string) => {
  return input
    .toLowerCase()
    .replace(/(^\w)/g, g => g[0].toUpperCase())
    .replace(/([-_.]\w)/g, g => ' ' + g[1].toUpperCase())
    .trim()
}

/**
 * A snake_case key as a sentence. Case is kept past the first letter, so lowercase a SCREAMING_SNAKE key first.
 *
 * @example toSentenceCase('fixed_quantity') // 'Fixed quantity'
 */
export const toSentenceCase = (input: string): string => capitalize(input.replace(/_/g, ' '))

/** A stored value as a label, or a dash when the row carries none. */
export const toTitleCaseOrDash = (input: string | null | undefined): string =>
  input ? toTitleCase(input) : PLACEHOLDERS.DASH
